import { Box } from '@mui/material';
import { CandidateEditForm } from 'core/candidate/edit-form';
import { useParams } from 'react-router-dom';

const EditPage = () => {
    const {candidateId} = useParams();

    if (!candidateId) return null;

    return (
        <Box>
            <CandidateEditForm tempWorkerId={Number(candidateId)} />
        </Box>
    );
};

export { EditPage };